<div id="navigation">
  <div class="profile-picture">
    <i class="material-icons md-48">account_circle</i>
    <div class="stats-label text-color">
      <span class="font-extra-bold font-uppercase"
        >{{ firstname }} {{ lastname }}</span
      >

      <div class="dropdown" dropdown>
        <a dropdown-toggle class="dropdown-toggle" data-toggle="dropdown">
          <small class="text-muted">logged in user<b class="caret"></b></small>
        </a>
        <ul class="dropdown-menu am-t-xs">
          <li><a>View Profile (Not Implemented)</a></li>
          <li class="divider"></li>
          <li><a (click)="logout()">Logout</a></li>
        </ul>
      </div>
    </div>
  </div>

  <ul side-navigation class="nav" id="side-menu">
    <li>
      <a>
        <span class="nav-label">Accounts</span>
      </a>
      <ul class="nav nav-second-level">
        <li>
          <a
            [routerLink]="['accountsnew']"
            routerLinkActive="router-link-active"
            >Account List</a
          >
        </li>
      </ul>
      <ul class="nav nav-second-level">
        <li>
          <a [routerLink]="['transfer']" routerLinkActive="router-link-active"
            >Transfer Data</a
          >
        </li>
      </ul>
      <ul class="nav nav-second-level" *ngIf="user | auth: 'trusted'">
        <li>
          <a
            [routerLink]="['accounts/manual']"
            routerLinkActive="router-link-active"
            >Manual Setup</a
          >
        </li>
      </ul>
      <!-- <ul class="nav nav-second-level" *ngIf="(user | auth: 'trusted')">
        <li>
          <a [routerLink]="['users']" routerLinkActive="router-link-active"
            >Users</a
          >
        </li>
      </ul> -->

      @if (isAdminListAvaialable$ | async) {
        <ul
          class="nav nav-second-level collapse"
          *ngIf="user | auth: 'trusted'"
          aria-expanded="false"
        >
          <li>
            <a [routerLink]="['admins']" routerLinkActive="router-link-active"
              >Admin List</a
            >
          </li>
        </ul>
      }
    </li>
    <li *ngIf="user | auth: 'trusted'">
      <a>
        <span class="nav-label">Organization</span>
      </a>
      <ul class="nav nav-second-level">
        <li>
          <a
            [routerLink]="['organization/setup']"
            routerLinkActive="router-link-active"
            >Organization Setup</a
          >
        </li>
      </ul>
      @if (sageSalesforceIntegration$ | async) {
        <ul class="nav nav-second-level collapse">
          <li>
            <a
              [routerLink]="['organization/LMNAccount']"
              routerLinkActive="router-link-active"
              >Create LMN Account</a
            >
          </li>
        </ul>
      }
      <ul class="nav nav-second-level">
        <li>
          <a
            [routerLink]="['accounts/strategic']"
            routerLinkActive="router-link-active"
            >Strategic Enterprises</a
          >
        </li>
      </ul>
      <ul class="nav nav-second-level">
        <li>
          <a
            [routerLink]="['organization/groundsguyssync']"
            routerLinkActive="router-link-active"
            >Grounds Guys Sync</a
          >
        </li>
      </ul>
    </li>
    <li>
      <a>
        <span class="nav-label">News</span>
      </a>
      <ul class="nav nav-second-level">
        <li>
          <a [routerLink]="['news']" routerLinkActive="router-link-active"
            >Edit News List</a
          >
        </li>
      </ul>
    </li>
    <li>
      <a>
        <span class="nav-label">Reports</span>
      </a>
      <ul class="nav nav-second-level">
        <li>
          <a
            [routerLink]="['reports/accounts']"
            routerLinkActive="router-link-active"
            >Accounts</a
          >
        </li>
        <li>
          <a
            [routerLink]="['reports/referrals']"
            routerLinkActive="router-link-active"
            >Referrals</a
          >
        </li>
        <li>
          <a
            [routerLink]="['reports/csm-review']"
            routerLinkActive="router-link-active"
            >CSM Review</a
          >
        </li>
        <li>
          <a
            [routerLink]="['reports/survey']"
            routerLinkActive="router-link-active"
            >Account Survey</a
          >
        </li>
        <li>
          <a
            [routerLink]="['reports/email']"
            routerLinkActive="router-link-active"
            >Email</a
          >
        </li>
        <li>
          <!--Sam Hallak - LM-245 - 26 July 2017 -->
          <a
            [routerLink]="['reports/cancellation']"
            routerLinkActive="router-link-active"
            >Cancellation Report</a
          >
        </li>
      </ul>
    </li>
    <li>
      <a>
        <span class="nav-label">Workshop</span>
      </a>
      <ul class="nav nav-second-level">
        <li>
          <a (click)="workshopAccounts()">Generate Accts</a>
        </li>
        <li>
          <a (click)="setupWorkshopAccounts()">Setup Accounts</a>
        </li>
        <li>
          <a (click)="workshopPasswords()">Reset Passwords</a>
        </li>
      </ul>
    </li>
    <li>
      <a>
        <span class="nav-label">Tools</span>
      </a>
      <ul class="nav nav-second-level">
        <li *ngIf="user | auth: 'trusted'">
          <a
            [routerLink]="['tools/copyestimates']"
            routerLinkActive="router-link-active"
            >Copy Estimates</a
          >
        </li>
        <li>
          <a
            [routerLink]="['tools/portal-user-purge']"
            routerLinkActive="router-link-active"
            >Portal User Purge</a
          >
        </li>
        <li>
          <a
            [routerLink]="['tools/lmn-user-unlink']"
            routerLinkActive="router-link-active"
            >LMN User Unlink</a
          >
        </li>
        <li *ngIf="user | auth: 'trusted'">
          <a
            [routerLink]="['tools/siteone-materials']"
            routerLinkActive="router-link-active"
            >SiteOne Materials</a
          >
        </li>
      </ul>
    </li>
    <li *ngIf="user | auth: 'trusted'">
      <a>
        <span class="nav-label">Analytics</span>
      </a>
      <ul class="nav nav-second-level">
        <li>
          <a
            [routerLink]="['dashboards/multidashboards']"
            routerLinkActive="router-link-active"
            >Dashboard Lists</a
          >
        </li>
      </ul>
    </li>
    <li *ngIf="user | auth: 'trusted'">
      <a>
        <span class="nav-label">Beta Test Accounts</span>
      </a>
      <ul class="nav nav-second-level">
        <li>
          <a
            [routerLink]="['multibetatestaccount']"
            routerLinkActive="router-link-active"
            >Beta Test Accounts</a
          >
        </li>
      </ul>
    </li>
    <li *ngIf="user | auth: 'trusted'">
      <a>
        <span class="nav-label">Configuration</span>
      </a>
      <ul class="nav nav-second-level">
        <li>
          <a
            [routerLink]="['configurations/configuration']"
            routerLinkActive="router-link-active"
            >Configuration Overrides</a
          >
        </li>
        <li>
          <a
            [routerLink]="['configurations/registrationPromotion']"
            routerLinkActive="router-link-active"
            >Registration Promotions</a
          >
        </li>
      </ul>
    </li>
    <li *ngIf="user | auth: 'trusted'">
      <a>
        <span class="nav-label">Franchise</span>
      </a>
      <ul class="nav nav-second-level">
        <li>
          <a
            [routerLink]="['franchises/franchiseGroup']"
            routerLinkActive="router-link-active"
            >Franchise Groups</a
          >
        </li>
        <li>
          <a
            [routerLink]="['franchises/franchiseList']"
            routerLinkActive="router-link-active"
            >Franchise List</a
          >
        </li>
      </ul>
    </li>
  </ul>
</div>
